<template>
  <div>
    <el-row style="margin-bottom:20px">
        <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/director-workmaster' }">工作通</el-breadcrumb-item>
        <el-breadcrumb-item>帮忙</el-breadcrumb-item>
      </el-breadcrumb>
    </el-row>
    <div class="nav">
      <!-- 上半部分-->
      <div class="topnav">
        <!-- 上左边 -->
        <div class="topnavleft">
          <!-- logo -->
          <div class="top">
            <div>
              <img src="@/assets/community/back.png" alt="" class="top-left-img" @click="back" />
            </div>
            <div>
              <img src="@/assets/work/bangzhu.png" alt="" class="top-midlle-img" />
            </div>
            <div class="top-midlle-span">帮助详情</div>
          </div>
          <!-- logo下面的文字 -->
          <div class="topb">
            <div class="topbtext">
              <p v-if="info.bid_status==-1">待投标</p>
              <p v-if="info.bid_status==0">已投标</p>
              <p v-if="info.bid_status==1">已中标</p>
              <p v-if="info.bid_status==2">已淘汰</p>
            </div>
            <!-- 中间文案 -->
            <section>
              <p class="toptitle_mid">{{ info.title }}</p>
              <span class="toptitle" style="border-color: #4d71d9">
                <a style="color: #4d71d9">工资{{ info.wages }}</a>
              </span>
              <span class="toptitle" style="border-color: #ff6e31">
                <a style="color: #ff6e31">佣金{{ info.commission }}</a>
              </span>
              <span class="toptitle" style="border-color: #03ba48">
                <a style="color: #03ba48">佣金{{ info.com_type|comTypesFilter }}</a>
              </span>
              <span class="toptitle" style="border-color: #03ba48">
                <a style="color: #03ba48">{{ info.com_settle_type|comSettleTypesFilter }}</a>
              </span>
            </section>
            <!-- 右边提交时间-->
            <div class="text_right">
              <p class="title_right">{{ info.js_time}}</p>
              <span class="title_right_bottom">截止时间</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 中间部分 -->
      <div class="mid">
        <!-- tab标签 -->
        <div class="tablabel">
          <!-- 招标信息 -->
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="招标信息" name="first">
              <div class="requirements">
                <div>
                  <p>项目标题</p>
                  <span>{{ info.title }}</span>
                </div>
                <div>
                  <p>员工工资</p>
                  <span>{{ info.wages }}元</span>
                </div>
                <div>
                  <p>佣金</p>
                  <span>{{ info.commission }} 元</span>
                </div>
              </div>
              <div class="requirements">
                <div>
                  <p>佣金方式</p>
                  <span>{{ info.com_type|comTypesFilter }}</span>
                </div>
                <div>
                  <p>佣金结算方式</p>
                  <span>{{ info.com_settle_type|comSettleTypesFilter }}</span>
                </div>
                <div>
                  <p>多人中标</p>
                  <span>允许</span>
                </div>
              </div>
              <div class="requirements">
                <div>
                  <p>起始时间</p>
                  <span>{{ info.start_at }}</span>
                </div>
                <div>
                  <p>结束时间</p>
                  <span>{{ info.end_at }}</span>
                </div>
                <div>
                  <p>允许投标名额</p>
                  <span>{{ info.bid_number }}人</span>
                </div>
              </div>

              <div class="requirements">
                <div>
                  <p>投标人地区</p>
                  <span>{{ info.region }}</span>
                </div>
                <div>
                  <p>投标人类型</p>
                  <span>社团</span>
                </div>
                <div>
                  <p>联系人</p>
                  <span>{{ info.contacts }}</span>
                </div>
              </div>

              <div class="requirements">
                <div>
                  <p>联系人电话</p>
                  <span>{{ info.mobile }}</span>
                </div>
                <div>
                  <p>邮箱地址</p>
                  <span>{{ info.email }}</span>
                </div>
              </div>

              <div class="requirements">
                <div>
                  <p>招标简介</p>
                  <span>{{ info.wages }}</span>
                </div>
              </div>

              <div class="requirements">
                <div>
                  <p>附件</p>
                  <span>{{ info.annex_name }}</span>
                </div>
                
              </div>
              <div class="requirements">
                <p>附件地址</p>
                <span>{{ info.annex_url }}</span>
              </div>
              <div class="requirements">
                <p>招标描述</p>
                <span>{{ info.description }}</span>
              </div>
            </el-tab-pane>
          <el-tab-pane label="全部投标" name="second">
            <div >
              <el-table :data="info.hasBid" >
                <el-table-column prop="alias_name" label="投标人" >
                </el-table-column>
                <el-table-column prop="created_at" label="投标时间">
                </el-table-column>
                <el-table-column prop="bid_status" label="是否中标">
                  <!--0待选标 1已中标 2已淘汰
                  -->
                  <template slot-scope="{row}">
                    <span v-if="row.bid_status == 0" style="color: #FF9004;">待选标</span>
                    <span v-if="row.bid_status == 1" style="color: #03ba48;">已中标</span>
                    <span v-if="row.bid_status == 2" style="color: #FF4E4E;">已淘汰</span>
                  </template>  
                </el-table-column>
              
              </el-table>
            </div>
          </el-tab-pane>
          </el-tabs>
        </div>
      </div>

      <!-- 底部部分 -->
      <div class="bottom">
        <span class="bottom_left">
          <section class="bottom_share">
            <i class="el-icon-share"></i>分享
          </section>
          <section class="bottom_share">
            <i class="el-icon-star-off"></i>收藏
          </section>
          <section class="bottom_share">
            <i class="el-icon-star-off"></i>投诉
          </section>
        </span>
        <section class="botton_right">


          <el-button type="primary" v-if="info.bid_status==-1" @click="touBiao">投标</el-button>
          <el-button type="primary" v-if="info.bid_status==0">已投标</el-button>
          <el-button type="primary" v-if="info.bid_status==1">已中标</el-button>
          <el-button type="primary" v-if="info.bid_status==2">已淘汰</el-button>

        </section>
      </div>
    </div>
    <bid-dialog ref="bidDialogRef"></bid-dialog>

  </div>
</template>

<script>
import { webCrowdIndexInfo } from "@/api/director/package/index";
import bidDialog from "./dialog/bid-dialog.vue";

export default {
  components: {
    bidDialog,
  },
  data() {
    return {
      crowd_id:"",
      corpor_id:"",
      info: {},
      activeName: "first",

    };
  },

  filters: {
    comSettleTypesFilter(status) {
      const statusMap = {
        1: '日结',
        2: '周结',
        3: '月结',
        4:'完工结',
        5:'入职结'
      }
      return statusMap[status]
    },
    comTypesFilter(status) {
      const statusMap = {
        1: '按人',
        2: '按件',
        3: '总价',
      }
      return statusMap[status]
    }
  },

  mounted() {

    if (this.$route.query.crowd_id != "") {
      this.crowd_id = this.$route.query.crowd_id;
      this.corpor_id = this.$route.query.corpor_id;

      this.initData();
      // 获取接口
    }
  },

  methods: {

    // 获取列表的方法
    initData() {
      webCrowdIndexInfo({ crowd_id: this.crowd_id }).then((res) => {
        console.log(res);
        if (res.code == 200) {
          this.info = res.data;
        } else {
          this.$message.error(res.msg ? res.msg : "请求错误");
        }
      });
    },

   

    touBiao(){
      this.$refs.bidDialogRef.init(this.crowd_id,this.corpor_id);

    },

    formatDateTime(value) { // 时间戳转换日期格式方法
      if (value == null) {
        return ''
      } else {
        const date = new Date(value)
        const y = date.getFullYear() // 年
        let MM = date.getMonth() + 1 // 月
        MM = MM < 10 ? ('0' + MM) : MM
        let d = date.getDate() // 日
        d = d < 10 ? ('0' + d) : d
        let h = date.getHours() // 时
        h = h < 10 ? ('0' + h) : h
        let m = date.getMinutes()// 分
        m = m < 10 ? ('0' + m) : m
        let s = date.getSeconds()// 秒
        s = s < 10 ? ('0' + s) : s
        return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s
      }
    },



    back() {
      this.$router.go(-1);
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
  },
};
</script>

<style lang="scss" scoped>
.nav {
  width: 100%;

  .topnav {
    height: 152px;
    background-color: white;
    display: flex;
    justify-content: space-between;

    .topnavleft {
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .topb {
        display: flex;
        justify-content: space-between;
        padding-bottom: 38px;
        width: 980px;
        margin-right: 25px;
      }

      .topbtext {
        width: 133px;

        p {
          font-size: 32px;
          color: #181818;
          font-weight: bold;
        }
      }

      .toptitle {
        margin: 0 auto;
        font-size: 10px;
        height: 20px;
        width: 80px;
        border-style: solid;
        border-radius: 3px;
        margin-right: 20px;
      }

      .toptitle_mid {
        height: 16px;
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #000000;
        margin-bottom: 10px;
      }

      .title_right {
        width: 175px;
        height: 16px;
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #000000;
        margin-bottom: 15px;
      }

      .title_right_bottom {
        width: 58px;
        height: 14px;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #666666;
      }

      .text_right {
        text-align: center;
        margin-right: 30px;
      }
    }

    .topnavright-img {
      width: 72px;
      height: 72px;
      margin: 41px 43px 39px 0px;
    }
  }

  .mid {
    width: 100%;
    height: 750px;
    background-color: white;
    margin-top: 10px;
    margin-bottom: 10px;
  }

  .bottom {
    height: 40px;
    background: #ffffff;
    border-radius: 16px;
    display: flex;
  }

  .bottom_share {
    width: 42px;
    height: 14px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #000000;
  }

  .bottom_left {
    width: 350px;
    display: flex;
    justify-content: space-between;
  }

  .botton_right {
    width: 630px;
    display: flex;
    justify-content: flex-end;
  }

  .el-button--small {
    width: 90px;
    height: 35px;
    background: #4d71d9;
    border-radius: 8px;
  }
}

.top {
  // width: 950px;
  height: 31px;
  display: flex;
}

.top-left-img {
  margin-top: 8px;
  width: 25px;
  height: 25px;
}

.top-midlle-img {
  width: 40px;
  height: 40px;
}

.top-midlle-span {
  margin-left: 20px;
  margin-top: 8px;
  height: 16px;
  font-size: 16px;
  color: #181818;
  font-weight: bold;
}

.top-right {
  margin-top: 2px;
  margin-left: 740px;
}

.tablabel {

  // width: 200px;
  p {
    font-size: 11px;
    color: #acacac;
    margin-bottom: 12px;
  }

  span {
    font-size: 11px;
    font-weight: bold;
    color: #000000;
  }

  .information {
    margin-top: 26px;

    div {
      width: 81px;
    }
  }

  .information:nth-child(1) {
    margin-top: 10px;
    display: flex;

    div {
      margin-right: 260px;
      width: 300px;
    }

    div:nth-last-child(1) {
      margin: 0;
    }
  }

  .information:nth-child(2) {
    margin-top: 10px;
    display: flex;

    div {
      margin-right: 260px;
    }

    div:nth-last-child(1) {
      margin: 0;
    }
  }

  .information:nth-child(3) {
    display: flex;

    div {
      margin-right: 260px;
      width: 300px;
    }

    div:nth-last-child(1) {
      margin: 0;
    }
  }

  .information:nth-child(4) {
    display: flex;

    p {
      height: 11px;
    }

    span {
      color: #4d71d9;
    }

    div {
      margin-right: 42px;
    }

    div:nth-last-child(1) {
      margin: 0;
    }
  }

  .requirements {
    margin-top: 26px;

    div {
      width: 81px;
    }
  }

  .requirements:nth-child(1) {
    margin-top: 10px;
    display: flex;

    div {
      margin-right: 260px;
    }

    div:nth-last-child(1) {
      margin: 0;
    }
  }

  .requirements:nth-child(2) {
    display: flex;

    div {
      margin-right: 260px;
    }

    div:nth-last-child(1) {
      margin: 0;
    }
  }

  .requirements:nth-child(3) {
    display: flex;

    div {
      margin-right: 260px;
    }

    div:nth-last-child(1) {
      margin: 0;
    }
  }

  .requirements:nth-child(4) {
    display: flex;

    div {
      margin-right: 260px;
    }

    div:nth-last-child(1) {
      margin: 0;
    }
  }

  .requirements:nth-child(5) {
    display: flex;

    div {
      margin-right: 260px;
    }

    div:nth-last-child(1) {
      margin: 0;
    }
  }

  .requirements:nth-child(6) {
    display: flex;

    div {
      margin-right: 260px;
      width: 300px;
    }

    div:nth-last-child(1) {
      margin: 0;
    }
  }

  .requirements:nth-child(7) {
    display: flex;

    p {
      height: 11px;
    }

    span {
      color: #4d71d9;
    }

    div {
      margin-right: 42px;
    }

    div:nth-last-child(1) {
      margin: 0;
    }
  }
}

::v-deep .el-tabs__nav-wrap::after {
  width: auto;
}

::v-deep .el-tabs__item {
  color: #acacac;
}

::v-deep .el-tabs__item.is-active {
  color: #4d71d9;
}

::v-deep .el-tabs__active-bar {
  height: 3px;
}
</style>
